var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSol = function SvgSol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.488 15.159a.501.501 0 0 1 .354-.147h12.22a.25.25 0 0 1 .177.428l-2.414 2.414a.501.501 0 0 1-.354.146H4.251a.25.25 0 0 1-.177-.427l2.414-2.415Z",
    fill: "url(#sol_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.488 6.145A.515.515 0 0 1 6.842 6h12.22a.25.25 0 0 1 .177.427L16.825 8.84a.501.501 0 0 1-.354.147H4.251a.25.25 0 0 1-.177-.428l2.414-2.414Z",
    fill: "url(#sol_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.825 10.623a.501.501 0 0 0-.354-.146H4.251a.25.25 0 0 0-.177.427l2.414 2.414c.092.092.22.146.354.146h12.22a.25.25 0 0 0 .177-.427l-2.414-2.414Z",
    fill: "url(#sol_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__a",
    x1: -23.62,
    y1: 3.732,
    x2: -23.945,
    y2: 20.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__b",
    x1: -27.318,
    y1: 1.801,
    x2: -27.643,
    y2: 18.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__c",
    x1: -25.481,
    y1: 2.76,
    x2: -25.806,
    y2: 19.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
};
export { SvgSol as ReactComponent };
export default "data:image/svg+xml;base64,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";